import React, { useState } from "react";

const DEFAULT_LIMIT = 5;

/**
 * Reusable hashtag list for admin pages. Fetches from the PostgREST `tags` API
 * using the polymorphic tagged_type/tagged_id pair. Displays hashtag names inline
 * with a "+N more" toggle when there are many.
 *
 * Usage:
 *   <AdminHashtagList tags={tags} />
 *   <AdminHashtagList tags={tags} limit={10} />
 */
function AdminHashtagList({ tags, limit = DEFAULT_LIMIT }) {
  const [expanded, setExpanded] = useState(false);

  if (!tags || tags.length === 0) return null;

  const visible = expanded ? tags : tags.slice(0, limit);
  const hiddenCount = tags.length - limit;

  return (
    <div className="mb-3">
      {visible.map((tag, idx) => (
        <span key={tag.hashtag_name || idx} className="text-muted small me-2">
          {tag.hashtag_name}
        </span>
      ))}
      {hiddenCount > 0 && !expanded && (
        <button type="button" className="btn btn-link btn-sm p-0 text-muted small" onClick={() => setExpanded(true)}>
          +{hiddenCount} more
        </button>
      )}
    </div>
  );
}

export default AdminHashtagList;
